export default {
	"sendGoods": {
		"printStockList": "พิมพ์รายการสต็อคสินค้า",
		"sendGoodsHandle": "ส่ง",
		"andSelfNo": "เลขที่คำสั่งสำหรับการรับสินค้าเอง ",
		"subSelfNo": "ยกเลิกการรับสินค้าเอง",
		"tips": "มีใบส่งสินค้าซ้ำกันในคำสั่งจัดส่งนี้ คุณต้องเลือกหมายเลขคำสั่งโอนเพื่อจัดส่ง",
		"cancelSendGoods": "ยกเลิกสินค้า",
		"deliverNo": "ใบแจ้งหนี้",
		"sendGoodsDialog": "ข้อมูลการจัดส่ง",
		"tagAnomalyDialog": "ข้อมูลข้อยกเว้นการจัดส่งในใบส่งสินค้า",
		"andSelfDialog": "แนบท้ายคำสั่งรับสินค้า",
		"transferBillList": "โอนรายการคำสั่ง",
		"deliveryName": "เจ้าหน้าที่จัดส่งสินค้า",
		"deliveryTime": "เวลาขนส่ง",
		"cancelTransferBill": "ท่านแน่ใจว่าต้องการยกเลิกคำสั่งโอนนี้หรือไม่",
		"validataTips1": "กรุณากรอกจำนวนบรรจุภัณฑ์ตามจริง",
		"validataTips2": "กรุณากรอกจำนวนบรรจุภัณฑ์ที่เสียหาย",
		"validataTips3": "ยกเลิกการจัดส่งสินค้าสำเร็จ",
		"validataTips4": "การยกเลิกการจัดส่งสินค้าไม่สำเร็จ",
		"validataTips5": "กรุณาเลือกหมายเลขคำสั่งโอนเดียวกันเพื่อทำใบส่งสินค้าใหม่"
	},
	"transferDelivery": {
		"sendGoods": "ส่ง",
		"sendGoodsCompleteTime": "เวลาที่รับสินค้าเสร็จสมบูรณ์",
		"sendGoodsComplete": "จัดส่งเสร็จสมบูรณ์",
		"downloadDeliverNo": "พิมพ์ใบแจ้งหนี้",
		"deliveredContainerQty": "จำนวนใบส่งสินค้าสำหรับตู้คอนเทนเนอร์",
		"transferNums": "คำสั่ง",
		"deliveredPackingQty": "จำนวนฉลากบรรจุภัณฑ์",
		"transferBillInfo": "โอนข้อมูลคำสั่ง",
		"losePackingDialogTitile": "ไม่มีข้อมูลบรรจุภัณฑ์",
		"startDeliveryDt": "เริ่มเวลาขนส่ง",
		"dispatchingDt": "กำหนดเวลา",
		"fileNum": "แนบเอกสารแล้ว",
		"Tips1": "บรรจุภัณฑ์ที่ยังไม่ได้สแกน ได้แก่",
		"Tips2": "กรุณายืนยันว่าบรรจุภัณฑ์ในรายการสูญหายหรือไม่",
		"identification": "เลขประจำตัวของพนักงานขับรถ"
	},
	"transferList": {
		"appointmentHandle": "มีการนัดหมาย",
		"expectedReceiveTime": "วางแผนเวลาของสินค้า",
		"actualReceiveTime": "เวลาจัดส่งตามจริง",
		"expectedDeliveryTime": "วางแผนเวลาจัดส่ง",
		"actualDeliveryTime": "เวลาจัดส่งตามจริง",
		"affixedCodeType": "และรหัสที่ถูกนำมาวาง",
		"receiveRouteNo": "สินค้าจัดส่งด้วยหมายเลขเดียว",
		"receiveTransportNo": "รับหมายเลขใบตราส่งสินค้า",
		"deliveryTransportNo": "ส่งหมายเลขใบตราส่งสินค้า",
		"deliveryRouteNo": "การจัดส่งด้วยหมายเลขเดียว",
		"planDeliveryDt": "จองเวลาการจัดส่ง",
		"planReceiveDt": "นัดหมายเวลารับสินค้า",
		"receiveDispatcherName": "ผู้รับสินค้าที่จัดส่ง",
		"receiveComplete": "สินค้าจัดส่งเสร็จแล้ว",
		"packingContainer": "การพิมพ์ใบส่งสินค้าสำหรับตู้คอนเทนเนอร์",
		"collectGoods": "สินค้า",
		"filesManageShowHide": "รายการที่ระบุตามเอกสารแนบ",
		"acPacking": "หมายเลขบรรจุภัณฑ์ที่ชำระเงินแล้ว/ได้รับ",
		"receivedGoodsTemperature": "อุณหภูมิเป็นองศาเซลเซียสสำหรับการรับสินค้า",
		"patchLabel": "สำหรับการติดฉลาก",
		"labelNo": "หมายเลขป้ายกำกับ",
		"labelType": "ประเภทป้ายกำกับ",
		"printPackingTag": "พิมพ์ฉลากบรรจุภัณฑ์",
		"storePlace": "ที่ตั้ง",
		"tagNumber": "หมายเลขป้ายกำกับ",
		"storeReceivePlace": "ที่ตั้งสินค้า",
		"containNum": "หมายเลขตู้คอนเทนเนอร์สำหรับบรรจุภัณฑ์ที่บรรจุด้านใน",
		"number": "หมายเลขตู้คอนเทนเนอร์",
		"source": "ที่มาของใบส่งสินค้า",
		"scaned": "สแกนแล้ว",
		"goodsInfoDialog": "ข้อมูลผู้รับตราส่งหรือผู้ส่งสินค้า",
		"tag": "ใบส่งสินค้า",
		"damagedPackingQty": "ความเสียหายของหมายเลขบรรจุภัณฑ์",
		"tips1": "ใบส่งสินค้าสำหรับสถานะการรับเพื่อแก้ไขข้อมูล",
		"tips2": "ได้รับใบส่งสินค้าแล้ว สามารถแก้ไขข้อมูลหลังคลิ๊ก \"ยื่น\"",
		"tagTitle": "ติดฉลากข้อมูลข้อยกเว้นของสินค้า",
		"reason": "ทำไม",
		"copyAll": "คัดลอกข้อมูลทั้งหมด",
		"appointmentTitle": "เพื่อใช้เป็นข้อมูล",
		"mapTracking": "แสดงการติดตามรถ",
		"distance": "ระยะทาง ณ ปัจจุบัน",
		"deliveryBillTypeStr": "ประเภทใบแจ้งหนี้",
		"tempControlName": "ประเภทของอุณหภูมิ",
		"validataTips1": "กรุณาเลือกสถานที่",
		"validataTips2": "กรุณาเลือกที่มาของใบส่งสินค้า",
		"validataTips3": "กรุณาใส่หมายเลขป้ายกำกับ",
		"receiveSuccess": "การรับสินค้าสำเร็จ",
		"validataTips4": "กรุณากรอกหมายเลขตู้คอนเทนเนอร์",
		"validataTips5": "กรุณากรอกหมายเลขตู้คอนเทนเนอร์ที่บรรจุหีบห่ออยู่ด้านใน",
		"validataTips6": "กรุณากรอกหมายเลขป้ายกำกับ",
		"validataTips7": "ต้องตรวจสอบข้อมูลที่ได้รับสถานะแล้ว",
		"validataTips8": "ท่านแน่ใจว่าต้องการรับการดำเนินงานหรือไม่",
		"validataTips9": "การดำเนินการสำเร็จ",
		"validataTips10": "การดำเนินการไม่สำเร็จ",
		"validataTips11": "ทำเครื่องหมายถูกที่สถานะ 'ไม่สามารถจัดส่งได้'",
		"validataTips12": "ท่านแน่ใจว่าต้องการให้การดำเนินการไม่มีผลใช้ได้หรือไม่",
		"validataTips13": "เมื่อได้รับสินค้ากรุณากรอกตัวเลข ระหว่าง 100 ถึง 100",
		"validataTips14": "กรุณาเลือกไม่ส่งต่อรายการโอนที่ทำขึ้นจากใบแจ้งหนี้",
		"validataTips15": "กรุณาเลือกสถานะการขนส่ง 'พักสินค้า' หรือ 'ได้รับรายการโอนแล้ว'",
		"validataTips16": "สถานที่ขนถ่ายสินค้าต้องเป็นที่เดียวกัน",
		"validataTips17": "รายการโอนทั้งหมดต้องเจ้าของเดียวกัน",
		"validataTips18": "กรุณาเลือกแผนสำหรับช่วงเวลาการจัดส่ง",
		"validataTips19": "การจองสำเร็จ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/transfer/transfer.js